import { initialRaceState, IRaceState } from '../state/race.state';
import { RaceActions, ERaceActions } from '../actions/race.actions';
import {IEventState, initialEventState} from '../state/event.state';
import {EEventActions, EventActions} from '../actions/event.actions';

export const eventReducers = (
    state = initialEventState,
    action: EventActions
): IEventState => {
    switch (action.type) {
        case EEventActions.GetEventSuccess: {
            return {
                ...state,
                event: action.payload
            };
        }

        case EEventActions.GetResetEvent: {
            return {
                ...state,
                event: action.payload
            };
        }

        default:
            return state;
    }
};
